import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";

import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);

export default {
	name: 'PackingReport',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		JsonExcel,
		download,
		Loader,
		BasicSelect
	},
	props: [],
	data() {
		return {
			mid: '',
			isLoadingforxls: false,
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// totalRows:0,
			// currentPage: 0,
			formattedDate: '',
			resultCount: '',
			ClientErr: '',
			WarehouseErr: '',
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			pono: '',
			orderid: '',
			productid: '',
			ProductID: '',
			clientproductid: '',
			boxid: '',
			AwbNo: '',
			transporter: '',
			fromdate: '',
			todate: '',
			user_type: '',
			// perPage: 10,
			// pageno: 0,
			// totalPage: 0,
			isLoading: false,
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			showSelectMerchant: false,
			csvFields: [],
			listPackingReportData: [],
			listPackingReportDataCsv: [],
			listClientData: [],
			listWarehouseData: [],
			transporterList: [],
			channellist: [],
			listMerchantData: [],
			saleschannel: '',
			userid: '',
			merchantname: '',
			recordLimit: 0,
			limitExeed: false,
			item: {
				value: '',
				text: ''
			},
			listMerchantData1: [{ value: '', text: this.$t('common.selectMerchantPlaceHolder') }],
			searchbtoborder:1,
			activemrpflag:false,
			rtvType:''
		}
	},
	computed: {

	},
	filters: {
		moment: function (date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YYYY');
		}
	},
	watch: {
        searchbtoborder: function() {
			this.listPackingReportData=[];
			this.totalRows = 0;
			if(this.searchbtoborder==1)
			{
					this.csvFields = {
						'orderid': this.$t('orders.orderId'),
						'itemid': this.$t('orders.orderItemId'),
						'boxid': this.$t('common.boxId'),
						'awbno':  this.$t('common.awbNo'),
						'shippingcompany': this.$t('inwardList.printData.transporter'),
						'productid': this.$t('common.productId'),
						'eancode': this.$t('common.eanCode'),
						'mrp':this.$t('common.mrp'),
						'activemrp':this.$t('common.activemrp'),
						'quantity': this.$t('packingReportList.table.columns.packedQty'),
						'saleschannel': this.$t('common.salesChannel'),
						'createddatetime': this.$t('packingReportList.table.columns.packedDate'),
						'createdby': this.$t('packingReportList.table.columns.packedBy'),
						'merchantname': this.$t('common.merchantName'),
						'packingboxname': this.$t('packingReportList.table.columns.packingBoxId'),
						'packboxlbh': this.$t('packingReportList.table.columns.PackingBoxLBH'),
						'packingboxweight': this.$t('editedjson.packingBoxWeight')
					};
					this.csvFieldsForXls[this.$t('orders.orderId')]='orderid';
					this.csvFieldsForXls[this.$t('orders.orderItemId')]='itemid';
					this.csvFieldsForXls[this.$t('common.boxId')]='boxid';
					this.csvFieldsForXls[this.$t('common.awbNo')]='awbno';
					this.csvFieldsForXls[this.$t('inwardList.printData.transporter')]='shippingcompany';
					this.csvFieldsForXls[this.$t('common.productId')]='productid';
					this.csvFieldsForXls[this.$t('common.eanCode')]='eancode';
					this.csvFieldsForXls[this.$t('common.mrp')]='mrp';
					if(this.activemrpflag === true){
						this.csvFieldsForXls[this.$t('common.activemrp')]='activemrp';
					}
					this.csvFieldsForXls[this.$t('packingReportList.table.columns.packedQty')]='quantity';
					this.csvFieldsForXls[this.$t('common.salesChannel')]='saleschannel';
					this.csvFieldsForXls[this.$t('packingReportList.table.columns.packedDate')]='createddatetime';
					this.csvFieldsForXls[this.$t('packingReportList.table.columns.packedBy')]='createdby';
					this.csvFieldsForXls[this.$t('common.merchantName')]='merchantname';
					this.csvFieldsForXls[this.$t('packingReportList.table.columns.packingBoxId')]='packingboxname';
					this.csvFieldsForXls[this.$t('packingReportList.table.columns.PackingBoxLBH')]='packboxlbh';
					this.csvFieldsForXls[this.$t('editedjson.packingBoxWeight')]='packingboxweight'
			}
			else{
				this.csvFields = {
					'orderid':  this.$t('orders.orderId'),
					'itemid': this.$t('orders.orderItemId'),
					'boxid': this.$t('common.boxId'),
					'awbno': this.$t('common.awbNo'),
					'shippingcompany': this.$t('inwardList.printData.transporter'),
					'productid':this.$t('common.productId'),
					'eancode': this.$t('common.eanCode'),
					'mrp': this.$t('common.mrp'),
					'activemrp': this.$t('common.activemrp'),
					'quantity': this.$t('packingReportList.table.columns.packedQty'),
					'saleschannel': this.$t('common.salesChannel'),
					'createddatetime':this.$t('packingReportList.table.columns.packedDate'),
					'createdby': this.$t('packingReportList.table.columns.packedBy'),
					'merchantname': this.$t('common.merchantName'),
					'suggestedboxname': this.$t('editedjson.suggestedPackingBox'),
					'packingboxname': this.$t('editedjson.selectedPackingBox'),
					'packboxlbh': this.$t('packingReportList.table.columns.PackingBoxLBH'),
					'packingboxweight': this.$t('editedjson.packingBoxWeight')
				};
				this.csvFieldsForXls[this.$t('orders.orderId')]='orderid';
				this.csvFieldsForXls[this.$t('orders.orderItemId')]='itemid';
				this.csvFieldsForXls[this.$t('common.boxId')]='boxid';
				this.csvFieldsForXls[this.$t('common.awbNo')]='awbno';
				this.csvFieldsForXls[this.$t('inwardList.printData.transporter')]='shippingcompany';
				this.csvFieldsForXls[this.$t('common.productId')]='productid';
				this.csvFieldsForXls[this.$t('common.eanCode')]='eancode';
				this.csvFieldsForXls[this.$t('common.mrp')]='mrp';
				if(this.activemrpflag === true){
				  this.csvFieldsForXls[this.$t('common.activemrp')]='activemrp';
			 }
				this.csvFieldsForXls[this.$t('packingReportList.table.columns.packedQty')]='quantity';
				this.csvFieldsForXls[this.$t('common.salesChannel')]='saleschannel';
				this.csvFieldsForXls[this.$t('packingReportList.table.columns.packedDate')]='createddatetime';
				this.csvFieldsForXls[this.$t('packingReportList.table.columns.packedBy')]='createdby';
				this.csvFieldsForXls[this.$t('common.merchantName')]='merchantname';
				this.csvFieldsForXls[this.$t('editedjson.suggestedPackingBox')]='suggestedboxname';
				this.csvFieldsForXls[this.$t('editedjson.selectedPackingBox')]='packingboxname';
				this.csvFieldsForXls[this.$t('packingReportList.table.columns.PackingBoxLBH')]='packboxlbh';
				this.csvFieldsForXls[this.$t('editedjson.packingBoxWeight')]='packingboxweight';
			}
        }
      },
	mounted() {
		this.calldateFunction();

		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyEmail = userdetail.email;
		this.userid = userdetail.userid;
		this.user_type = userdetail.utype;
		this.reportname = this.$t('reports.productivityPackingReportFilename');
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!='undefined')
		{
		this.getMerchantList();
		this.getSalesChannels();
		this.getTransporterList();
		}
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			// console.log(newValue+"===============in event")
			// Perform any other actions needed
			this.getTransporterList();
		  });
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getWarehouseList();
				this.getMerchantList();
				this.getActiveMrpFlag();
				if (userdetail.merchantid) {
					this.mid = userdetail.merchantid.toString()
					this.merchantname = this.mid
					this.showSelectMerchant = false;
				}
				break;

			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.searchbtoborder=0;
		this.getRecordLimit()
	},
	methods: {
		reset() {
			this.item = {}
		},
		onSelect(item) {
			// select option from parent component
			this.item = item
			this.merchantname = item.value;

		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},

		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getPackingReportListForXls(3)
			}
		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime);
			download(blob, filename, mime);
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			let bstr = atob(base64);
			let n = bstr.length;
			let u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		// getClientList() {
		// 	this.pageno = 0;

		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		getSalesChannels() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			if (localStorage.getItem("selectedClient") == '') {
				this.WarehouseErr = this.$t('srReport.clientError');
				return false;
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'orderSalesChannelList',
				'data': {
					clientid: localStorage.getItem("selectedClient")
				},
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.channellist = result.data.data;
				}, error => {
					console.error(error);
				});
		},
		// getWarehouseList() {
		// 	this.pageno = 0;

		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		getTransporterList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			this.input = ({
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient")
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'courierMasterList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.transporterList = result.data.data.rows;
				}, error => {
					console.error(error)
				})
		},

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantname = '';
		// 		if (this.clientid)
		// 			this.getSalesChannels();
		// 		this.getTransporterList();
		// 		this.getMerchantList();
		// 		this.getActiveMrpFlag();
		// 		this.item = {}
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getActiveMrpFlag();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			this.getActiveMrpFlag();
		// 			// this.getPackingReportList();
		// 		}
		// 	}
		// 	this.listPackingReportData = [];
		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			this.getSalesChannels();
		// 			this.getTransporterList();

		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getMerchantList() {
			this.listMerchantData1 = []
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						var merchantListArray = [];
						result.data.forEach(function (item) {
							merchantListArray[item.merchantid] = item.merchantname;
						});
						this.merchantList = merchantListArray;
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantData1 = [{ value: '', text: this.$t('common.selectMerchantPlaceHolder') }];
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname

							})
						})
					}
				}, error => {
					console.error(error)
				})
		},
		async getActiveMrpFlag(){
 				 var userToken = window.localStorage.getItem('userToken');
 				 var myStr = userToken.replace(/"/g, '');
 				 this.input = ({
 					 "clientid": localStorage.getItem("selectedClient"),
 				 });
 			 try {

 					 axios({
 							 method: 'POST',
 							 'url': apiUrl.api_url + 'checkActivemrpFlg',
 							 'data': this.input,
 							 headers: {
 								 'Authorization': 'Bearer ' + myStr,
 							 }
 						 })
 						 .then(result => {
 							 if(result.data.data.data[0].value ==='yes'){
 								 this.activemrpflag = true;
 							 }else{
 								 this.activemrpflag = false;
 							 }
 						 }, error => {
 							 console.error(error);
 						 });

 				 } catch (err) {
 					 throw new Error(err);
 				 }
 	 },
		getPackingReportListSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.getPackingReportList(2);
		},
		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.todate = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.fromdate = dt;
		},
		//to get client list
		getPackingReportList(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}

			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.listPackingReportData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.listPackingReportData = [];
				return false;
			}
			if (this.orderid == '' && (this.fromdate == '' || this.fromdate == null) && (this.todate == '' || this.todate == null)) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.listPackingReportData = [];
				this.totalRows = 0;
				return false;
			}
			var months;
			var fromDate = new Date(this.fromdate);
			var ToDate = new Date(this.todate);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

			if (this.orderid == '' && months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				this.listPackingReportData = [];
				return false;
			}
			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate, 0)
			}
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat(this.todate, 1)
			}
			// if (csvCheck != 1)
			//this.pageno = 0;
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				awbno: this.AwbNo,
				transporter: this.transporter,
				pono: this.orderid,
				productid: this.ProductID,
				boxid: this.boxid,
				fromddate: fr_date,
				todate: to_date,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				csvData: csvCheck,
				searchchannel: this.saleschannel,
				userid: this.userid,
				merchantid: this.merchantname,
				rtvType:this.rtvType
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			let packingApiName=""
			if(this.searchbtoborder==1)
			 packingApiName="packingReportb2b"
			 else
			 packingApiName="packingReport"
			this.isLoading = true;
			axios({
				method: 'POST',
				'url': apiUrl.api_url + packingApiName,
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.data.length > 0) {
							this.show = true;
							this.download = false;
							this.listPackingReportDataCsv = [];


							var dateFilter = [];
							if(this.activemrpflag === true){
								var skipFilter = ['id','count'];
							}else {
								var skipFilter = ['id','count','activemrp'];
							}
							this.listPackingReportDataCsv = result.data.data;
							csvHelper.data.jsonToCSV(this.$t('reports.productivityPackingReportFilename'), this.listPackingReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

							// this.jsonToCSV('PackingReport', this.listPackingReportDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					} else {
						this.listPackingReportData = result.data.data;
						if (result.data.errorCode == -1) {
							this.resultCount = 0;
							this.totalRows = 0;
							this.$alertify.error(result.data.msg);
						} else {
							this.totalRows = result.data.count;
							this.resultCount = result.data.count;
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							if (this.totalRows <= this.pageLimit) {
								this.totalPage = 1;
							} else {
								this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		getPackingReportListForXls(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			var dataFilter = {};
			var dataFilter = {};
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';


			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate, 0)
			}
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat(this.todate, 1)
			}
			// if (csvCheck != 1)
			//this.pageno = 0;
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				awbno: this.AwbNo,
				transporter: this.transporter,
				pono: this.orderid,
				productid: this.ProductID,
				boxid: this.boxid,
				fromddate: fr_date,
				todate: to_date,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				csvData: csvCheck,
				searchchannel: this.saleschannel,
				userid: this.userid,
				merchantid: this.merchantname,
				rtvType:this.rtvType
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			let packingApiName=""
			if(this.searchbtoborder==1)
			 packingApiName="packingReportb2b"
			 else
			 packingApiName="packingReport"
			axios({
				method: 'POST',
				'url': apiUrl.api_url + packingApiName,
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listReportDataforxls = [];


							this.listReportDataforxls = result.data.data;
							// this.listReportDataforxls.forEach(function (entry) {
							// 	if (entry.createddatetime != '' && entry.createddatetime != null) {
							// 		entry.createddatetime = moment(entry.createddatetime).format('YYYY-MM-DD HH:mm:ss');

							// 	}

							// });
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}


					}


				}, error => {
					console.error(error);
				})
		},
		//to get pagination
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * this.perPage;
		// 	this.getPackingReportList();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getPackingReportList()
		},

		dateFormat(date, toFrom) {
			if (!toFrom)
				toFrom = '00:00:00'
			else
				toFrom = '23:59:59'
			if (!date)
				return '';
			return moment(date).format('YYYY-MM-DD ' + toFrom);
		},

		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},

		//to reset search form
		resetSearchForm() {
			this.show = false;
			this.download = true;
			this.orderid = '';
			this.ProductID = '';
			this.boxid = '';
			this.AwbNo = '';
			this.merchantname = '',
				this.item = {
					value: '',
					text: ''
				};
			this.saleschannel = '';
			this.transporter = '';
			this.pageno = 0;
			this.totalRows = 0;
			this.listPackingReportData = [];
			this.fromdate = '';
			this.todate = '';
			this.searchFlag = false;
			this.searchbtoborder=0;
			this.rtvType='';
			// if (this.user_type == 'warehouse_user') {
			// 	this.clientid = '';
			// 	this.listMerchantData1 = [{ value: '', text: this.$t('common.merchantPlaceholder') }];
			// }
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.clientid = '';
			// 	this.warehouse = '';
			// 	this.listMerchantData1 = [{ value: '', text: this.$t('common.merchantPlaceholder') }];

			// }
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/packingreport/packingreport.component.js